import { render } from "./ViewRequestLogs.vue?vue&type=template&id=2758a810&scoped=true"
import script from "./ViewRequestLogs.vue?vue&type=script&lang=js"
export * from "./ViewRequestLogs.vue?vue&type=script&lang=js"

import "./ViewRequestLogs.vue?vue&type=style&index=0&id=2758a810&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2758a810"]])

export default __exports__